import type { Degree, Distance, Margins, Pixel, Point, Radian, Rectangle } from "#public"
import type { SpatialRectangle } from "#public"

import { ToMargins } from "../public/spatial/ToMargins"

export const ZERO_DISTANCE = 0 as Distance
export const ZERO_PIXEL = 0 as Pixel
export const ZERO_DEGREE = 0 as Degree
export const ZERO_RADIAN = 0 as Radian

export const ZERO_POINT: Point<Distance> = { x: ZERO_DISTANCE, y: ZERO_DISTANCE }

export const ZERO_RECTANGLE: Rectangle<Distance> = { width: ZERO_DISTANCE, height: ZERO_DISTANCE }

// oxlint-disable-next-line pdfking/prefer-record-merge-dependency -- @pdfking/tfunc depends on this package
export const ZERO_SPATIAL_RECTANGLE: SpatialRectangle<Distance> = {
  ...ZERO_POINT,
  ...ZERO_RECTANGLE,
}

export const ZERO_MARGINS: Margins<Distance> = ToMargins(ZERO_DISTANCE)
